import "../Styles/about.css";
import myphoto from "../Images/myphoto.png";
import Sagar_Kumar_Resume from "../files/Sagar_Kumar_Resume.pdf";

const About = ({ ref, func }) => {
  const handleDownload = () => {
    window.open(
      "https://drive.google.com/file/d/1-9CWG--Il53xhItf1NewcgsL4UuLzsDN/view?usp=sharing"
    );
    const link = document.createElement("a");
    link.href = Sagar_Kumar_Resume;
    link.setAttribute("download", "Sagar_Kumar_Resume.pdf");
    link.setAttribute("id", "resume-link-2");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="about section" id="about" ref={ref} onScroll={func}>
      <h1 className="about-me">
        About <span style={{ color: "#0e4166" }}>Me</span>
      </h1>

      <div className="image-des">
        <div>
          <img className="home-img" src={myphoto} alt="myimage" />
        </div>
        <div>
          <p id="user-detail-intro">
            Dynamic full stack web developer with strong command over the MERN
            stack, including React, Node.js, Express, and MongoDB. Skilled in
            building scalable web applications through solo and team projects.
            Excellent problem-solving, teamwork, and communication abilities.
            Eager to contribute in a fast-paced development
            environment.Well-versed in RESTful APIs, responsive design, and
            Git-based version control. Quick learner with a passion for clean
            code and continuous improvement. Capable of adapting to new
            technologies and collaborating effectively in cross-functional
            teams.
          </p>
          <div className="resume-button" id="resume-button-2">
            <button className="download-button" onClick={handleDownload}>
              <div className="docs">
                <svg
                  className="css-i6dzq1"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  fill="none"
                  strokeWidth="2"
                  stroke="currentColor"
                  height="20"
                  width="20"
                  viewBox="0 0 24 24"
                >
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line y2="13" x2="8" y1="13" x1="16"></line>
                  <line y2="17" x2="8" y1="17" x1="16"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>{" "}
                Resume
              </div>
              <div className="download">
                <svg
                  className="css-i6dzq1"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  fill="none"
                  strokeWidth="2"
                  stroke="currentColor"
                  height="24"
                  width="24"
                  viewBox="0 0 24 24"
                >
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                  <polyline points="7 10 12 15 17 10"></polyline>
                  <line y2="3" x2="12" y1="15" x1="12"></line>
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
